// New Year 2026 Theme Configuration
export const newYear2025Theme = {
  id: 'newyear2025',
  name: 'New Year 2026',
  colors: {
    primary: '#FFD700',
    secondary: '#FF6B6B',
    accent: '#4ECDC4'
  },
  snow: {
    enabled: true,
    color: '#ffffff',
    intensity: 'medium'
  },
  confetti: {
    enabled: true,
    colors: ['#FFD700', '#FF6B6B', '#4ECDC4', '#A855F7', '#F472B6', '#38BDF8'],
    count: 80
  },
  fireworks: {
    enabled: true,
    interval: 3500
  },
  countdown: {
    enabled: true,
    targetDate: '2026-01-01T00:00:00'
  },
  banner: {
    enabled: true,
    text: '🎊 Cheers to 2026! New Dreams, New Adventures Await! 🥂',
    backgroundColor: 'linear-gradient(135deg, #FF6B6B 0%, #FFD700 50%, #4ECDC4 100%)'
  },
  particles: {
    balloons: true,
    stars: true
  }
};
